module.exports = __webpack_public_path__ + "img/1486764158.d33ca81c.jpg";